var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInformationCircleSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.152 19.4h-4.304v-.99l.662-.003a.663.663 0 0 0 .663-.662v-3.311a.66.66 0 0 0-.663-.662h-.662v-.99h2.98v4.963c0 .365.296.662.662.662l.662.003zM15 9.8a.992.992 0 1 1 .001 1.985A.992.992 0 0 1 15 9.8M15 7a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
})));
export default SvgInformationCircleSolid;